import { formatOtsDateTime } from "@ots-frontend/ots-data";

const EMPTY = "—";

/** "06:48", through the shared formatter (`formatOtsDateTime`). */
export const formatActivityTime = (value?: number, timeZone?: string): string =>
  value == null ? EMPTY : formatOtsDateTime(value, "time", { timeZone });

/** "Oct 5, 15:10", through the shared formatter. */
export const formatActivityDateTime = (value?: number, timeZone?: string): string =>
  value == null ? EMPTY : formatOtsDateTime(value, "short", { timeZone });

export const formatActivityDuration = (millis?: number): string => {
  if (millis == null) return EMPTY;
  const minutes = Math.round(millis / 60_000);
  const hours = Math.floor(minutes / 60);
  return hours > 0 ? `${hours}h ${String(minutes % 60).padStart(2, "0")}m` : `${minutes}m`;
};

const quantityFormat = new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 });
const moneyFormat = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export const formatActivityQuantity = (value?: number, uom?: string): string =>
  value == null ? EMPTY : `${quantityFormat.format(value)}${uom ? ` ${uom}` : ""}`;

export const formatActivityMoney = (value?: number): string => value == null ? EMPTY : moneyFormat.format(value);
